import { render } from "./ProfileFields.vue?vue&type=template&id=113ad4e6&scoped=true"
import script from "./ProfileFields.vue?vue&type=script&lang=js"
export * from "./ProfileFields.vue?vue&type=script&lang=js"

import "./ProfileFields.vue?vue&type=style&index=0&id=113ad4e6&scoped=true&lang=css"

import exportComponent from "C:\\Users\\abscu\\OneDrive\\Desktop\\htmlcss\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-113ad4e6"]])

export default __exports__